<template>
  <div class="pt-10 pt-md-13 pt-lg-16">
    <TitleWidget class="text-center"> Produtos </TitleWidget>

    <LoadingWidget v-if="loading" class="py-0 py-md-13 py-lg-16" />

    <transition name="fade">
      <div v-if="!loading && items.length" class="mt-md-10">
        <template v-for="(item, keyItems) in items">
          <ProductCard
            :class="{
              'border-item': keyItems % 2 !== 0 && items.length == keyItems + 1,
            }"
            v-bind="item"
            :left="keyItems % 2 == 0"
            :key="keyItems"
          />
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import { formatToURL } from "../utils/formatToURL";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import ProductCard from "../components/cards/ProductCard.vue";

const _config = {
  mod: "products",
  path: "/produtos",
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
    itemsPerPage: 100,
    items: [],
  }),
  mounted() {
    this.get();
  },
  methods: {
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({
          params: { itemsPerPage: this.itemsPerPage },
        })
        .then((data) => {
          this.items = data.map(({ id, img, title, introduction }) => ({
            img,
            title,
            introduction,
            to: `${this.path}/${formatToURL(title)}-${id}`,
          }));
        })
        .then(() => (this.loading = false));
    },
  },
  watch: {
    $route() {
      this.get();
    },
  },
  components: {
    TitleWidget,
    LoadingWidget,
    ProductCard,
  },
};
</script>

<style lang="scss" scoped>
.border-item {
  position: relative;

  &:before {
    background-color: rgba(0, 0, 0, 0.2);
    bottom: -1px;
    content: "";
    height: 1px;
    left: 0;
    position: absolute;
    width: 100%;
    z-index: 2;
  }
}
</style>
